/**
 * @generated SignedSource<<e028dc53a032657d79b35afb430e9ab3>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type BuildsIndicator_pipeline$fragmentType = any;
type CreateBuildDialog_pipeline$fragmentType = any;
export type PipelineVisibility = "PRIVATE" | "PUBLIC" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type Header_pipeline$fragmentType: FragmentType;
export type Header_pipeline$data = {|
  +archived: boolean,
  +color: ?string,
  +description: ?string,
  +emoji: ?string,
  +id: string,
  +name: string,
  +organization: {|
    +iconUrl: ?string,
    +name: string,
    +slug: string,
  |},
  +permissions: {|
    +buildCreate: {|
      +allowed: boolean,
      +code: ?string,
      +message: ?string,
    |},
    +pipelineUpdate: {|
      +allowed: boolean,
      +code: ?string,
      +message: ?string,
    |},
  |},
  +repository: ?{|
    +provider: ?{|
      +__typename: string,
      +url: ?string,
    |},
    +url: string,
  |},
  +url: string,
  +visibility: PipelineVisibility,
  +$fragmentSpreads: BuildsIndicator_pipeline$fragmentType & CreateBuildDialog_pipeline$fragmentType,
  +$fragmentType: Header_pipeline$fragmentType,
|};
export type Header_pipeline$key = {
  +$data?: Header_pipeline$data,
  +$fragmentSpreads: Header_pipeline$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_pipeline",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateBuildDialog_pipeline"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuildsIndicator_pipeline"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iconUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "provider",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PipelinePermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "pipelineUpdate",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "buildCreate",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "30f11d13dc3c8aef72c40cafe18f0625";

module.exports = ((node/*: any*/)/*: Fragment<
  Header_pipeline$fragmentType,
  Header_pipeline$data,
>*/);
